import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postBlock = (params) => {
    return axios.post(`${backendHost}/api/admin/cashiers/block`, params);
};

export {
    postBlock
}